import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Slider from "@mui/material/Slider";
import { builder } from "Classes/global";
import { AssetType } from "Classes/enums";
import "./CMRTranformSliderComponent.scss";

const CMRHeightSlider = styled(Slider)(() => ({
    color: "#E7E7E7",
    height: 6,
    padding: "15px 0",
    "& .MuiSlider-thumb": {
        backgroundColor: "#E6117B",
    },
    "& .MuiSlider-track": {
        border: "none",
    },
    "& .MuiSlider-valueLabel": {
        background: "none",
        color: "black",
    },
}));

interface ComponentProps {
    title: string;
    target: string;
    property: "position" | "rotation" | "scale";
    axis: "x" | "y" | "z";
    min: number;
    max: number;
    step: number;
    defaultValue?: number;
}

const CMRTransformSliderComponent = ({
    title,
    target,
    property,
    axis,
    min,
    max,
    step,
    defaultValue = 0,
}: ComponentProps): JSX.Element => {
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    const handleSliderChange = (_event: Event, newValue: number | number[]): void => {
        if (typeof newValue !== "number") return;
        if (!builder.room.selectedObject) return;

        if (builder.room.selectedObject.type !== AssetType.PatientBed) {
            return;
        }

        Object.values(builder.room.SM_ibsu).forEach((bsu) => {
            if (!bsu.isSleepMode) {
                bsu.deactivateForBedMove();
            }
        });

        const patientBed = builder.room.selectedObject as {
            type: AssetType.PatientBed;
            SM_Patient: StaticMesh;
            SM_Bed: StaticMesh;
        };

        patientBed.SM_Patient.setNodeTransform(target, property, axis, newValue);

        const patientPosition = builder.room.currentConfiguration.patientPosition as {
            adjustments?: Array<{
                target: string;
                property: "position" | "rotation" | "scale";
                axis: "x" | "y" | "z";
                value: number;
            }>;
        };

        const adjustment = {
            target,
            property,
            axis,
            value: newValue,
        };

        const adjustments = patientPosition.adjustments ?? [];

        const existingIndex = adjustments.findIndex(
            (item) => item.target === target && item.property === property && item.axis === axis
        );

        if (existingIndex === -1) {
            patientPosition.adjustments = [...adjustments, adjustment];
        } else {
            patientPosition.adjustments = adjustments.map((item, index) =>
                index === existingIndex ? adjustment : item
            );
        }

        setValue(newValue);
    };

    return (
        <section className="sliderContainer">
            <h2>{title}</h2>

            <article className="slider">
                <CMRHeightSlider
                    onChange={handleSliderChange}
                    value={value}
                    min={min}
                    max={max}
                    step={step}
                    valueLabelDisplay="on"
                />
            </article>
        </section>
    );
};

export default CMRTransformSliderComponent;
